/**
 * Pre-compiled de messages for Pagination
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  currentPage: `Aktuelle Seite`,
  goToNextPage: `Weiter zur nächsten Seite`,
  goToPreviousPage: `Zur vorherigen Seite`,
  itemsPerPage: `Artikel pro Seite`,
  itemsPerPageText: `Artikel pro Seite`,
  ofTotalPages: (args: Record<string, string | number>) =>
    `von ${args.totalPages}`,
  page: `Seite`,
  pagination: `Seitennummerierung`,
};
